import { DEFAULT_PART_DATE_MASK, partPlaceholder } from '@inference.engine/taxonomy/web';
import type { TrackingCodePart } from '../model/types';

/** Human token for one pattern part (used in the preview chips / string). */
export function describePart(part: TrackingCodePart, fieldName?: string): string {
  switch (part.kind) {
    case 'field':
      // eslint-disable-next-line i18next/no-literal-string -- pattern placeholder tokens
      return `{${fieldName ?? 'field'}${part.source === 'value' ? ':value' : ''}}`;
    case 'literal':
      return part.text ?? '';
    case 'date': {
      // A cleared mask advertises NOTHING, because the generator emits nothing
      // for it. `{}` was the previous answer and was worse than `{YYYY}`: it
      // still occupied a chip, so it read as a token that renders empty rather
      // than as a part contributing no characters at all.
      const mask = part.format ?? DEFAULT_PART_DATE_MASK;
      return mask ? `{${mask}}` : '';
    }
    case 'sequence':
    case 'random':
      return partPlaceholder(part);
    default:
      return '';
  }
}

/** A pattern as a readable template, e.g. `{Trademark}-{Brand}-{YYYY}-#####`. */
export function patternText(
  pattern: readonly TrackingCodePart[],
  nameOf: (fieldId: string) => string | undefined,
  delimiter = '',
): string {
  return pattern
    .map((p) => describePart(p, p.fieldId ? nameOf(p.fieldId) : undefined))
    .filter((token) => !delimiter || token !== '')
    .join(delimiter);
}
